export function formatMonthlyPrice(priceMonthly: number | null): string {
  if (priceMonthly === null) return "お問い合わせ";
  if (priceMonthly === 0) return "無料";
  return `¥${priceMonthly.toLocaleString("ja-JP")} / 月`;
}
